module.exports = __webpack_public_path__ + "static/media/creativesMobile.59b0c16f.png";